import { render, staticRenderFns } from "./TarjetaMenu.vue?vue&type=template&id=8b903f34&scoped=true"
import script from "./TarjetaMenu.vue?vue&type=script&lang=js"
export * from "./TarjetaMenu.vue?vue&type=script&lang=js"
import style0 from "./TarjetaMenu.vue?vue&type=style&index=0&id=8b903f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b903f34",
  null
  
)

export default component.exports